import { api } from './client';

export interface AuditEntryDto {
  id: number;
  entityType: string;
  entityId: string;
  action: string;
  changedBy: string;
  changes: string;
  timestamp: string;
}

export const auditTrailApi = {
  list: (params: {
    entityType?: string;
    entityId?: string;
    from?: string;
    to?: string;
    limit?: number;
  } = {}) =>
    api.get<AuditEntryDto[]>('/audit/trail', params),
};
